<template lang="pug">
  b-badge(:variant="badgeVariant") {{ displayableStatus }}
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      default: 'Default'
    }
  },
  computed: {
    displayableStatus () {
      let status = 'Default'
      switch (this.status.toLowerCase()) {
        case 'on_hold':
          status = 'En espera'
          break
        case 'close':
          status = 'Cerrado'
          break
        case 'open':
          status = 'Abierto'
          break
      }

      return status
    },
    badgeVariant () {
      let variant = 'secondary'
      switch (this.status.toLowerCase()) {
        case 'on_hold':
          variant = 'primary'
          break
        case 'close':
          variant = 'danger'
          break
        case 'open':
          variant = 'success'
          break
      }

      return 'soft-' + variant
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
